import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook for showing/hiding header on scroll
 * Header shows when scrolling up or at top, hides when scrolling down
 */
export function useHeaderScroll() {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;

          // Show header when scrolling up or at the top
          if (currentScrollY < lastScrollY.current || currentScrollY < 10) {
            setIsVisible(true);
          }
          // Hide header when scrolling down (and not at the very top)
          else if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
            setIsVisible(false);
          }

          lastScrollY.current = currentScrollY;
          ticking.current = false;
        });

        ticking.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { isVisible };
}
